import { useEffect } from 'react';

interface SEOHeadProps {
  schema?: object;
}

export default function SEOHead({ schema }: SEOHeadProps) {
  useEffect(() => {
    if (schema) {
      // Remove existing schema script if any
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Add new schema script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);

      return () => {
        script.remove();
      };
    }
  }, [schema]);

  return null;
}
